import api from './api-caller';

export default {
  getContracts: () => {
    const endpoint = '/contracts/'
    return api(endpoint, 'GET')
  },
  updateStatus: (body, id) => {
    const endpoint = `/contracts/${id}`
    return api(endpoint, 'PATCH', body)
  }
}
